import { KdsText } from "@kazaar-platform/design-system";
import { useTranslate } from "@tolgee/react";

interface PreMediaCommentSectionProps {
  csmComment?: string;
}

export const PreMediaCommentSection = ({
  csmComment,
}: PreMediaCommentSectionProps) => {
  const { t } = useTranslate();

  return (
    <div className="flex flex-col gap-2 rounded-md bg-slate-50 p-4">
      <KdsText size="subtitle-sm">
        {t("order.myOrdersItemDetails.preMedia.comment")}
      </KdsText>
      <KdsText>{csmComment || ""}</KdsText>
    </div>
  );
};
